export const REGISTRATIONS_INFO_RESET = 'REGISTRATIONS_INFO_RESET';

export const REGISTRATIONS_INFO_FETCH_START = 'REGISTRATIONS_INFO_FETCH_START';
export const REGISTRATIONS_INFO_FETCH_SUCCESS = 'REGISTRATIONS_INFO_FETCH_SUCCESS';
export const REGISTRATIONS_INFO_FETCH_FAILURE = 'REGISTRATIONS_INFO_FETCH_FAILURE';

export const REGISTRATIONS_INFO_CREATE_START = 'REGISTRATIONS_INFO_CREATE_START';
export const REGISTRATIONS_INFO_CREATE_SUCCESS = 'REGISTRATIONS_INFO_CREATE_SUCCESS';
export const REGISTRATIONS_INFO_CREATE_FAILURE = 'REGISTRATIONS_INFO_CREATE_FAILURE';

export const REGISTRATIONS_INFO_UPDATE_START = 'REGISTRATIONS_INFO_UPDATE_START';
export const REGISTRATIONS_INFO_UPDATE_SUCCESS = 'REGISTRATIONS_INFO_UPDATE_SUCCESS';
export const REGISTRATIONS_INFO_UPDATE_FAILURE = 'REGISTRATIONS_INFO_UPDATE_FAILURE';

export const REGISTRATIONS_INFO_DELETE_START = 'REGISTRATIONS_INFO_DELETE_START';
export const REGISTRATIONS_INFO_DELETE_SUCCESS = 'REGISTRATIONS_INFO_DELETE_SUCCESS';
export const REGISTRATIONS_INFO_DELETE_FAILURE = 'REGISTRATIONS_INFO_DELETE_FAILURE';

export const REGISTRATIONS_DE_REGISTER_START = 'REGISTRATIONS_DE_REGISTER_START';
